<script>
    import Link from "../shared/Link.svelte";
    import DownloadList from "./DownloadList.svelte";
    import { _ } from "svelte-i18n";
</script>

<div class="downloads">
  <h2>{$_("download_page.h2-0")}</h2>
  <p>
    {$_("download_page.p-0-1")}
    <Link target="mailto:guidewalk.geraet@gmail.com" newPage={true}>guidewalk.geraet@gmail.com</Link>
    {$_("download_page.p-0-2")}
  </p>
  <h3>{$_("download_page.h3-0")}</h3>
  <DownloadList download_ids={["WQnhY", "2Jmfy"]}/>
  <h3>{$_("download_page.h3-1")}</h3>
  <DownloadList download_ids={["APf1g", "HQerk", "Pv9Rq"]}/>
</div>

<style>
  h2 {
    background: -webkit-linear-gradient(90deg, #2eb6e8, #80f1ef);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>